import React, { useRef, useState, useEffect, useCallback } from 'react';
import '../styles/gallery.css';

// Import dining images
import dining1 from '../assets/images/dining_7.jpg';
import dining2 from '../assets/images/dining_1.jpg';
import dining3 from '../assets/images/dining_2.jpg';
import dining4 from '../assets/images/dining_3.jpg';
import dining5 from '../assets/images/dining_4.jpg';

const images = [dining1, dining2, dining3, dining4, dining5];

const DiningGallery = ({ language }) => {
  const scrollRef = useRef(null);
  const [modalImageIndex, setModalImageIndex] = useState(null);

  const scroll = (dir) => {
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  const openModal = (index) => {
    setModalImageIndex(index);
  };

  const closeModal = () => {
    setModalImageIndex(null);
  };

  const prev = useCallback(() => {
    if (modalImageIndex !== null) {
      setModalImageIndex((modalImageIndex - 1 + images.length) % images.length);
    }
  }, [modalImageIndex]);

  const next = useCallback(() => {
    if (modalImageIndex !== null) {
      setModalImageIndex((modalImageIndex + 1) % images.length);
    }
  }, [modalImageIndex]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (modalImageIndex !== null) {
        if (e.key === 'ArrowLeft') prev();
        if (e.key === 'ArrowRight') next();
        if (e.key === 'Escape') closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalImageIndex, prev, next]);

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
        <h2 className="fw-bold mb-4 text-center text-white">
          {language === 'am' ? 'የብሉ ኔስት ሆቴል ሬስቶራንት ጋለሪ' : 'Blue Nest Hotel Restaurant Gallery'}
        </h2>
        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => openModal(i)}>
                <img src={img} className="gallery-image" alt={`Blue Nest Hotel Restaurant ${i + 1}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {modalImageIndex !== null && (
        <div className="image-modal" onClick={closeModal}>
          <img 
            src={images[modalImageIndex]} 
            className="modal-img" 
            alt="Blue Nest Hotel Restaurant Preview" 
            onClick={(e) => e.stopPropagation()}
          />
          <button className="close-btn" onClick={closeModal}>×</button>
          <button className="nav-btn prev-btn" onClick={(e) => { e.stopPropagation(); prev(); }}>‹</button>
          <button className="nav-btn next-btn" onClick={(e) => { e.stopPropagation(); next(); }}>›</button>
        </div>
      )}
    </section>
  );
};

export default DiningGallery;
